import { useState } from 'react'
import CompanyNavbar from 'components/Navbars/CompanyNavbar'
import EditCompany from './Company'
import ChangePassword from './ChangePassword'
import { Container, TabRow, TabButton, Title } from './styles'

export default function Config () {
  const TAB_LIST = [
    {label: 'Meus dados', value: 'company_data', component: <EditCompany/>},
    {label: 'Alterar senha', value: 'change_password', component: <ChangePassword/>}
  ]

  const [selectedTab, setSelectedTab] = useState (TAB_LIST[0].value)
  
  return (
    <Container>
      <CompanyNavbar/>
      <Title>Configurações</Title>
      <TabRow>
        {TAB_LIST.map ((tab, index) => (
          <TabButton
            key={index}
            selected={selectedTab === tab.value}
            color={selectedTab === tab.value ? '#FFC100' : '#FFFFFF'}
            onClick={() => {
              setSelectedTab (tab.value)
              localStorage.setItem ('config_tab', tab.value)
            }}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabRow>
      {TAB_LIST.find (tab => tab.value === selectedTab).component}
    </Container>
  )
}
